import _ from 'lodash';
import React, { StrictMode, Suspense, useEffect, lazy } from 'react';
import ReactDOM from 'react-dom';
import { Loading, NetworkMonitor, navigate, ErrorBox } from '~/utils';
import { useSpatialNav } from '~/hooks';
import { log } from '@swiper/core';
import ErrorBoundary from 'react-error-boundary';
import {
  useGlobalContext, useConfig,
  GlobalContextProvider, ConfigProvider, InfoProvider,
} from './context';
import * as IdlePages from '~/idles';
import * as Overlays from '~/overlays';
import { Login } from './Login';

import app from './app';

import './icons';

import { unregister } from './serviceWorker';

import './styles.css';
import './reader.css';
// import './auth.css';
import 'bootstrap/dist/css/bootstrap.css';

const MainAppPage = lazy(
  () => import( /* webpackChunkName: "mainapp" */ '~/mainapp' ),
);
const ReaderPage = lazy(
  () => import( /* webpackChunkName: "reader" */ '~/reader' ),
);

window.app = app;

unregister();

// ReactDOM.createRoot( document.getElementById( 'root' ) ).render( (
ReactDOM.render( (
  <StrictMode>
    <Suspense fallback={<Loading/>}>
      <ErrorBoundary>
        <ConfigProvider>
          <InfoProvider>
            <GlobalContextProvider>
              <Main />
              <NetworkMonitor />
            </GlobalContextProvider>
          </InfoProvider>
        </ConfigProvider>
      </ErrorBoundary>
    </Suspense>
  </StrictMode>
), document.getElementById( 'root' ) );

// const Reader = lazy( () => import( '~/reader' ) );
// const Dashboard = lazy( () => import( '~/dashboard' ) );

function Main( props ) {
  const config = useConfig();
  // const [ idle, setIdle ] = useState( true );
  const { swipe, login, overlay } = useGlobalContext();

  useSpatialNav( shortcuts );

  useEffect( () => {
    if ( ! ( config && config.get ) ) return;
    document.body.id = config.get( 'station.type' );
  }, [ config ] );

  if ( ! config.loaded ) return <Loading />;

  // If we should be showing an overlay, then show that...
  if ( overlay ) {
    log.debug( 'OVERLAY ENABLED', overlay );
    const Overlay = overlay && Overlays[ overlay ];
    if ( Overlay ) {
      return <Overlay />;
    } else {
      return <ErrorBox error={`Unknown overlay "${overlay}"`} />;
    }
  }
  // If we have a logged-in user then we just display the main app.
  if ( login ) return <MainAppPage />;

  if ( config && config.has( 'station' ) ) {
    const IdlePage = _.get( IdlePages, config.get( 'idlePage' ) );
    if ( swipe ) {
      if ( swipe.error ) return <ErrorBox error={swipe.error} />;
      return <ReaderPage />;
    }
    if ( IdlePage ) return <IdlePage />;
  }

  return <Login />;
}

function shortcuts( key, ev, spatial ) {
  const nav = ( url ) => { navigate( url ); return true; };
  switch ( key ) {
    case 'F1':      return nav( '/info/help' );
    case 'F2':      return nav( '/info' );
    default:        return false;
  }
}
